import { useState, useEffect, useCallback } from 'react';
import { getSettings } from '../api/settings';
import type { SettingsByCategoryDto } from '../types/settings';

/**
 * Hook for fetching application settings grouped by category
 */
export function useSettings() {
  const [data, setData] = useState<SettingsByCategoryDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchSettings = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const settings = await getSettings();
      setData(settings);
    } catch (err) {
      const apiError = err as { response?: { data?: { message?: string } } };
      setError(apiError.response?.data?.message || 'Failed to fetch settings');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchSettings,
    setData,
  };
}
